import styled from 'styled-components';

import { Icon } from '../../../Icon';
import { Copy } from '../../../styles/Typography';

export const CTAWrapper = styled.div`
  width: 100%;
`;

export const StyledCopy = styled(Copy)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-weight: 700;
  padding: 1.2rem 2.4rem;
`;

export const StyledIcon = styled(Icon)`
  margin-right: 0.8rem;
`;
